<template>
    <div>
        <div v-if="canDisplayBoosts()">
            <div v-for="action in actionsList" :key="action.key">
                <div v-if="action.type === 'boost' && action.positions_opened_today < action.boosts" class="action_box">
                    Boost: 
                    <router-link
                        class="security_symbol"
                        :to="{ name: 'asset', params: { symbol: action.asset_symbol } }"
                    >{{ action.asset_symbol }}</router-link>
                    ({{ action.positions_opened_today }}/{{ action.boosts }})
                    <div class="buttons">
                        <div v-if="processingActions.includes(action.key)">
                            <b-spinner
                                small 
                                type="grow" 
                                class="button_spinner"
                                variant="primary"
                            ></b-spinner>
                        </div>
                        <div v-else>
                            <b-button 
                                size="sm" 
                                class="button_default" 
                                variant="primary" 
                                @click.prevent="submitBoost(action.asset_symbol)"
                            >
                                <strong>{{ buttonLabel(action.key) }}</strong>
                            </b-button>
                        </div>
                    </div>
                </div>

                <!--  Buy action currently disabled -->
                <div v-if="false && action.type === 'buy' && action.positions_opened_today < action.boosts" class="action_box">
                    <strong>
                        Buy 
                        <router-link
                            class="security_symbol"
                            :to="{ name: 'asset', params: { symbol: action.asset_symbol } }"
                        >{{ action.asset_symbol }}</router-link>
                        ({{ action.positions_opened_today }}/{{ action.boosts }})
                    </strong>

                    <div class="buttons">
                        <b-button 
                            size="sm" 
                            class="button_default" 
                            variant="info" 
                            @click.prevent="suggestBuy(action.asset_symbol)"
                        >
                            <strong>Buy {{ action.asset_symbol }}</strong>
                        </b-button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import apiMixin from '@/mixins/api';

export default {
    name: 'Actions',
    mixins: [apiMixin],
    data() {
        return {
            actionsList: [],
            processingActions: [],
        }
    },
    created() {
        this.retrieveActions();
    },
    methods: {
        canDisplayBoosts() {
            let d = new Date();
            
            // Convert to US Eastern Time
            let estTime = d.toLocaleString("en-US", { timeZone: "America/New_York" });
            let estHours = new Date(estTime).getHours();

            // Return true if the time is between 1 PM and 5 PM
            return estHours >= 13 && estHours < 17;
        },
        async retrieveActions() {
            const response = await this.apiGet('/api/actions-v2', null, { showToast: false });
            if (!response) return;

            this.actionsList = []; // reset the local list, new list is here
            let actions = response.data;
            var i;
            for (i = 0; i < actions.length; i++) {
                if (actions[i].type === 'boost') {
                    actions[i].key = "boost:".concat(actions[i].asset_symbol)
                }
                this.actionsList.push(actions[i])
            }
        },
        submitBoost(symbol) {
            this._boostAsset(symbol).then(() => {
                this.$store.dispatch('refreshData');
            });
        },
        buttonLabel(actionKey) {
            var i;                  
            for (i = 0; i < this.actionsList.length; i++) {
                if (this.actionsList[i].key === actionKey) {
                    if (this.actionsList[i].type === 'boost') {
                        return "Boost ".concat(this.actionsList[i].asset_symbol);
                    }
                }
            }
        },
        suggestBuy(symbol) {
            this.$emit('suggest-buy-symbol', symbol)
        },
        async _boostAsset(symbol) {
            const actionKey = "boost:".concat(symbol);
            this.processingActions.push(actionKey);

            try {
                const response = await this.apiPost('/api/boost/process', { symbol: symbol });
                if (response) {
                    this.retrieveActions();
                    this._removeAction(actionKey);
                }
                return response?.data;
            } finally {
                this.processingActions.splice(this.processingActions.indexOf(actionKey), 1);
            }
        },
        _removeAction(actionKey) {
            var i;                  
            for (i = 0; i < this.actionsList.length; i++) {
                if (this.actionsList[i].key === actionKey) {
                    this.actionsList.splice(this.actionsList[i], 1);
                }
            }
        }
    },
}
</script>

<style>

.action_box { 
    color: #000; 
    padding: 12px;
    border-top: 1px solid #ccc; 
    background-color: #fff3b0; 
    position: relative;
}
.buttons {
    position: absolute;
    right: 0px;
    margin-top: -28px;
}
.button_default {
    width: 100px;
    margin-right: 12px;
}
.button_spinner {
    margin-right: 54px;
}

</style>